/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NewsEntryLightReport', 'model/NewsEntry', 'model/NewsEntryFullReport', 'model/NewsEntryFilter', 'model/NewsEntryFullReportNewsEntryReportPaginationSlice', 'model/NewsEntryLightReportNewsEntryReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/NewsEntryLightReport'), require('../model/NewsEntry'), require('../model/NewsEntryFullReport'), require('../model/NewsEntryFilter'), require('../model/NewsEntryFullReportNewsEntryReportPaginationSlice'), require('../model/NewsEntryLightReportNewsEntryReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntryApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NewsEntryLightReport, root.ForStractionServiceApi.NewsEntry, root.ForStractionServiceApi.NewsEntryFullReport, root.ForStractionServiceApi.NewsEntryFilter, root.ForStractionServiceApi.NewsEntryFullReportNewsEntryReportPaginationSlice, root.ForStractionServiceApi.NewsEntryLightReportNewsEntryReportPaginationSlice);
  }
}(this, function(ApiClient, NewsEntryLightReport, NewsEntry, NewsEntryFullReport, NewsEntryFilter, NewsEntryFullReportNewsEntryReportPaginationSlice, NewsEntryLightReportNewsEntryReportPaginationSlice) {
  'use strict';

  /**
   * NewsEntry service.
   * @module api/NewsEntryApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new NewsEntryApi. 
   * @alias module:api/NewsEntryApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the newsEntryAddLightReportPut operation.
     * @callback module:api/NewsEntryApi~newsEntryAddLightReportPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addLightReport
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryLightReport} body 
     * @param {module:api/NewsEntryApi~newsEntryAddLightReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.newsEntryAddLightReportPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryAddLightReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryAddLightReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/NewsEntry/addLightReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryAddPut operation.
     * @callback module:api/NewsEntryApi~newsEntryAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntry} body 
     * @param {module:api/NewsEntryApi~newsEntryAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.newsEntryAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/NewsEntry/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryEditLightReportPut operation.
     * @callback module:api/NewsEntryApi~newsEntryEditLightReportPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editLightReport
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryLightReport} body 
     * @param {Integer} primaryKey 
     * @param {module:api/NewsEntryApi~newsEntryEditLightReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.newsEntryEditLightReportPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryEditLightReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryEditLightReportPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling newsEntryEditLightReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/NewsEntry/editLightReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryLoadFullReportPut operation.
     * @callback module:api/NewsEntryApi~newsEntryLoadFullReportPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntryFullReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadFullReport
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryFilter} body 
     * @param {Integer} entryID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.preloadedCommentsCount  (default to 0)
     * @param {Integer} opts.commentsOrder  (default to 0)
     * @param {Integer} opts.preloadedContributorsCount  (default to 0)
     * @param {module:api/NewsEntryApi~newsEntryLoadFullReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntryFullReport}
     */
    this.newsEntryLoadFullReportPut = function(_4SAPIAppID, body, entryID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryLoadFullReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryLoadFullReportPut";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling newsEntryLoadFullReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID,
        'preloadedCommentsCount': opts['preloadedCommentsCount'],
        'commentsOrder': opts['commentsOrder'],
        'preloadedContributorsCount': opts['preloadedContributorsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntryFullReport;

      return this.apiClient.callApi(
        '/NewsEntry/loadFullReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryLoadLightReportPut operation.
     * @callback module:api/NewsEntryApi~newsEntryLoadLightReportPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntryLightReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadLightReport
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryFilter} body 
     * @param {Integer} entryID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.preloadedCommentsCount  (default to 0)
     * @param {Integer} opts.commentsOrder  (default to 0)
     * @param {Integer} opts.preloadedContributorsCount  (default to 0)
     * @param {module:api/NewsEntryApi~newsEntryLoadLightReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntryLightReport}
     */
    this.newsEntryLoadLightReportPut = function(_4SAPIAppID, body, entryID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryLoadLightReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryLoadLightReportPut";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling newsEntryLoadLightReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID,
        'preloadedCommentsCount': opts['preloadedCommentsCount'],
        'commentsOrder': opts['commentsOrder'],
        'preloadedContributorsCount': opts['preloadedContributorsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntryLightReport;

      return this.apiClient.callApi(
        '/NewsEntry/loadLightReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntrySearchFullReportSlicePut operation.
     * @callback module:api/NewsEntryApi~newsEntrySearchFullReportSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntryFullReportNewsEntryReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchFullReportSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryFilter} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.sortMode  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {Integer} opts.preloadedCommentsCount  (default to 0)
     * @param {Integer} opts.commentsOrder  (default to 0)
     * @param {Integer} opts.preloadedContributorsCount  (default to 0)
     * @param {Boolean} opts.skipCountsData  (default to false)
     * @param {Boolean} opts.skipDetailedCountsData  (default to false)
     * @param {module:api/NewsEntryApi~newsEntrySearchFullReportSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntryFullReportNewsEntryReportPaginationSlice}
     */
    this.newsEntrySearchFullReportSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySearchFullReportSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntrySearchFullReportSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'sortMode': opts['sortMode'],
        'order': opts['order'],
        'preloadedCommentsCount': opts['preloadedCommentsCount'],
        'commentsOrder': opts['commentsOrder'],
        'preloadedContributorsCount': opts['preloadedContributorsCount'],
        'skipCountsData': opts['skipCountsData'],
        'skipDetailedCountsData': opts['skipDetailedCountsData']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntryFullReportNewsEntryReportPaginationSlice;

      return this.apiClient.callApi(
        '/NewsEntry/searchFullReportSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntrySearchLightReportSlicePut operation.
     * @callback module:api/NewsEntryApi~newsEntrySearchLightReportSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntryLightReportNewsEntryReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchLightReportSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryFilter} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.sortMode  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {Integer} opts.preloadedCommentsCount  (default to 0)
     * @param {Integer} opts.commentsOrder  (default to 0)
     * @param {Integer} opts.preloadedContributorsCount  (default to 0)
     * @param {Boolean} opts.skipCountsData  (default to false)
     * @param {Boolean} opts.skipDetailedCountsData  (default to false)
     * @param {module:api/NewsEntryApi~newsEntrySearchLightReportSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntryLightReportNewsEntryReportPaginationSlice}
     */
    this.newsEntrySearchLightReportSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySearchLightReportSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntrySearchLightReportSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'sortMode': opts['sortMode'],
        'order': opts['order'],
        'preloadedCommentsCount': opts['preloadedCommentsCount'],
        'commentsOrder': opts['commentsOrder'],
        'preloadedContributorsCount': opts['preloadedContributorsCount'],
        'skipCountsData': opts['skipCountsData'],
        'skipDetailedCountsData': opts['skipDetailedCountsData']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntryLightReportNewsEntryReportPaginationSlice;

      return this.apiClient.callApi(
        '/NewsEntry/searchLightReportSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
